import styled from 'styled-components'
import {colors} from "../../utils/colors";
import {ErrorWrapper, Loader} from "../../utils/styles/Atoms";
import {Profil} from "../../models/Profil";
import {Card} from "../../components/Card";
import {useFetch} from "../../utils/hooks";

const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 100px;
`

const PageTitle = styled.h1`
  font-size: 30px;
  color: black;
  text-align: center;
  padding-bottom: 30px;
`

const PageSubtitle = styled.h2`
  font-size: 20px;
  color: ${colors.secondary};
  font-weight: 300;
  text-align: center;
  padding-bottom: 30px;
`

export function Freelances() {

    // get datas, error and loading
    const {data, error, isLoading} = useFetch<Profil[]>('/freelances')

    if (error) {
        return <ErrorWrapper>Oups il y a eu un problème</ErrorWrapper>
    }

    return (
        <div>
            <PageTitle>Trouvez votre prestataire</PageTitle>
            <PageSubtitle>
                Chez Shiny nous réunissons les meilleurs profils pour vous.
            </PageSubtitle>

            {
                isLoading ? <Loader/>
                    :
                    <CardsContainer>
                        {data.map((profile: Profil, index) => (
                            <Card
                                key={`${profile.name}-${index}`}
                                profil={profile}
                            />
                        ))}
                    </CardsContainer>
            }
        </div>
    )
}
